<template>
	<div class="input-wrapper app-field" :class="props.class">
		<input
			v-model="modelValue"
			class="border rounded bg-white"
			:type="type"
			:required="required"
			:disabled="isDisabled"
			v-bind="{ ...$attrs }"
		/>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useUserStore } from "@/store/useUserStore";
import { ValueType } from "@/enums/ValueType";

defineOptions({
	inheritAttrs: false,
});

const props = withDefaults(
	defineProps<{
		type?: string;
		class?: string;

		required?: boolean;
		readOnly?: boolean;
		valueType?: ValueType.String | ValueType.Boolean | ValueType.None;
	}>(),
	{
		required: false,
		readOnly: false,
		type: "text",
		valueType: ValueType.String,
	},
);

const modelValue = defineModel<string | number | boolean | undefined>();

const userStore = useUserStore();
const isDisabled = computed(() => {
	return props.readOnly || userStore.user?.role !== "intermediary";
});
</script>

<style scoped lang="scss">
.input-wrapper {
	position: relative;

	> input {
		width: 100%;
		cursor: inherit;

		border: none;
		padding: 0.25rem 0.5rem;
		color: inherit;
		font-family: inherit;

		&[disabled] {
			background-color: transparent;
		}

		&:not([disabled]) {
			border: 1px solid var(--border);
		}
	}
}
</style>
